{
    "Profile_LiabilityExposures.title": "FR: Liability Exposures",
    "Profile_LiabilityExposures.multipleLocations": "FR: Do you own/rent more than one location?",
    "Profile_LiabilityExposures.weeksLocationRented": "FR: Number of weeks location rented to others?",
    "Profile_LiabilityExposures.roomsRented": "FR: Number of rooms rented to others?",
    "Profile_LiabilityExposures.daycareChildren": "FR: Daycare operation - number of children",
    "Profile_LiabilityExposures.trampoline": "FR: Do you own a trampoline?",
    "Profile_LiabilityExposures.gardenTractor": "FR: Do you have a garden tractor?",
    "Profile_LiabilityExposures.golfCart": "FR: Do you have a golf cart?",
    "Profile_LiabilityExposures.saddleAnimals": "FR: Number of saddle/draft animals?",
    "Profile_LiabilityExposures.recreationalVehicles": "FR: Do you own any unlicensed recreational vehicles?",
    "Profile_LiabilityExposures.renewableEnergy": "FR: Renewable energy installation on premises?",
    "Profile_LiabilityExposures.watercrafts": "FR: Do you own any watercrafts?",
    "Profile_LiabilityExposures.fullTimeEmployees": "FR: Number of full time residence employees?",
    "Profile_LiabilityExposures.coOccupant": "FR: Is there a co-occupant that requires coverage?",
    "Profile_LiabilityExposures.coOccupantName": "FR: Co-occupant name",
    "Profile_LiabilityExposures.businessOperation": "FR: Is there any kind of business operation?",
    "Profile_LiabilityExposures.describeBusinessOperation": "FR: if yes, describe business",
    "Profile_LiabilityExposures.numberOfDogs": "FR: Number of dogs in the household?",
    "Profile_LiabilityExposures.breedOfDogs": "FR: Breed(s) of dogs",
    "Profile_LiabilityExposures.propertyArea": "FR: Total property area (if greater than 1 acre) in acre",
    "Profile_LiabilityExposures.cannabisPlants": "FR: Number of cannabis plants grown on premises?",
    "Profile_LiabilityExposures.otherExposures": "FR: Other exposures"
}
